module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQMAAAD+wSzIAAAAA1BMVEXjT2bf7sSEAAAACklEQVQI12NAAwAAEAABtKqAHwAAAABJRU5ErkJggg=="